import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'zag-card',
  templateUrl: './zag-card.component.html',
  styleUrl: './zag-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZagCardComponent {
  clickable = input<boolean>(false);
  cardClick = output<void>();

  onClick(): void {
    if (this.clickable()) {
      this.cardClick.emit();
    }
  }

  onKeyActivate(event: KeyboardEvent): void {
    if (this.clickable() && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      this.cardClick.emit();
    }
  }
}
